import type { ReactNode } from 'react';
import { Animated, type StyleProp, type ViewStyle } from 'react-native';
import { useEntranceAnimation } from './useAnimations';

interface FadeInProps {
  children: ReactNode;
  delay?: number;
  duration?: number;
  translateY?: number;
  /** Initial scale to settle from (e.g. 0.96 for a subtle pop). Defaults to 1. */
  scaleFrom?: number;
  style?: StyleProp<ViewStyle>;
}

export function FadeIn({
  children,
  delay = 0,
  duration = 600,
  translateY = 20,
  scaleFrom = 1,
  style,
}: Readonly<FadeInProps>) {
  const { style: animatedStyle } = useEntranceAnimation({
    delay,
    duration,
    translateY,
    scaleFrom,
  });

  return <Animated.View style={[animatedStyle, style]}>{children}</Animated.View>;
}
